module.exports = __webpack_public_path__ + "img/crewpages_logo_icon_dark.bc0c83d6.svg";